<template>
  <a-modal
    id="revert-object-modal"
    centered
    destroy-on-close
    :style="{ width: '40%' }"
    ok-text="Revert"
    :ok-button-props="{ loading: loading }"
    :visible="showRevertObject"
    title="Revert Objects"
    :mask-closable="false"
    @ok="handleRevertObjectSubmit"
    @cancel="handleRevertObjectCancel"
  >
    <a-space size="40" direction="vertical" class="w-100">
      <a-typography-title :level="4" class="ml-2 mt-2">
        Task Objects List
      </a-typography-title>
      <a-table
        class="mt-3"
        :data-source="taskObjects"
        :row-selection="{
          type: 'checkbox',
          selectedRowKeys: selectedObjects,
          onChange: onObjectSelectionChange,
        }"
        :columns="TaskObjectColumns"
        :row-key="'id'"
        :scroll="{ y: '40vh', x: true }"
        :pagination="false"
      >
        <template #emptyText>
          <div
            id="no-task-objects-found"
            style="height: 35vh"
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <laptop-outlined style="font-size: 40px" />
            <span class="mt-2">No Task Objects Found</span>
          </div>
        </template>
      </a-table>
    </a-space>
  </a-modal>
</template>

<script>
import { LaptopOutlined } from '@ant-design/icons-vue';
import taskObjectsMarking from 'src/services/taskObjectsMarking';
import { isDefaultObjects } from './config';

export default {
  components: {
    LaptopOutlined,
  },

  inject: ['toast'],

  props: {
    showRevertObject: { type: Boolean, default: false, required: true },
    selectedImages: { type: Array, default: () => {}, required: true },
    taskObjectsList: { type: Array, default: () => {}, required: true },
  },

  emits: ['setShowRevertObject', 'revertObjectsProcess'],

  data() {
    return {
      selectedRow: null,
      selectedObjects: [],
      taskObjects: [],
      TaskObjectColumns: [
        {
          title: 'Objects',
          dataIndex: 'name',
          key: 'name',
        },
      ],
      loading: false,
    };
  },

  computed: {
    rowSelection() {
      return {
        type: 'radio',
        selectedRowKeys: [this.selectedRow],
        onChange: this.onRowSelect,
      };
    },
  },

  watch: {
    taskObjectsList(value) {
      this.taskObjects = value.filter(
        (obj) => !obj.is_static && !isDefaultObjects(obj.name)
      );
    },
  },

  methods: {
    handleRevertObjectSubmit() {
      this.startRevertObjectProcess();
    },

    onObjectSelectionChange(selectedRowKeys) {
      this.selectedObjects = selectedRowKeys;
    },

    getSelectedImageKeys() {
      if (!this.selectedImages) return [];
      let keys = [];
      for (let key of Object.keys(this.selectedImages)) {
        if (this.selectedImages[key]) keys.push(Number(key));
      }
      return keys;
    },

    async startRevertObjectProcess() {
      const payload = {
        selected_objects: this.selectedObjects,
        record_ids: this.getSelectedImageKeys(),
      };
      this.loading = true;
      this.$emit('revertObjectsProcess', this.loading);
      const [error, data] = await taskObjectsMarking.revertObjectAnnotations(
        payload
      );
      this.loading = false;
      if (error) {
        this.toast.error('Failed to revert the selected object.');
        this.$emit('revertObjectsProcess', this.loading);
      } else {
        this.$emit('revertObjectsProcess', this.loading, data);
        this.toast.success('Objects successfully reverted.');
      }

      this.handleRevertObjectCancel();
    },

    onRowSelect(selectedRowKeys) {
      this.selectedRow = selectedRowKeys[0];
    },

    handleRevertObjectCancel() {
      this.selectedRow = null;
      this.selectedObjects = [];
      this.$emit('setShowRevertObject', false);
    },
  },
};
</script>
